import { object, string } from 'yup';

const JobPostingUpdateSchema = object().shape({
  start_date: string().required('Please enter your start date'),
  job_title: string().required('Enter a job title'),
  type: string(),
  job_description: string(),
  rate: string().required('Please enter rate'),
});

export default JobPostingUpdateSchema;
